<template>
    <div>
        <div style="min-height: 60vh;" class="card d-flex">
            <div class="card-body">
                <div v-if="revision_data != null">
                    <b-row>
                        <b-col cols="12" class="mb-1">
                            <span class="bold">Title</span>
                            <div>{{ revision_data.title }}</div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" class="mb-1">
                            <span class="bold ">Issue Date</span>
                            <div>{{ issueDate }}</div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12">
                            <span class="bold">Author</span>
                            <div>{{ revision_data.author }}</div>
                        </b-col>
                    </b-row>
                </div>
                <div v-else>
                    <b-row v-if="sop_data">
                        <b-col cols="12" class="pb-2">
                            <span class="bold">Title</span>
                            <div>{{ sop_data.name }}</div>
                        </b-col>
                    </b-row>
                </div>
                <!-- builder mode toggle -->
                <b-row v-if="can_show_toggles">
                    <hr>
                    <b-col cols="12">
                        <span class="bold">
                            Document Mode
                        </span>
                        <div class="btn-group">
                            <b-button size="sm" @click="handleUpdateSopDocumentMode(true)" :variant="document_builder_enabled == true ? 'primary' : 'outline-dark'">
                                Builder
                            </b-button>
                            <b-button size="sm" @click="handleUpdateSopDocumentMode(false)" :variant="document_builder_enabled == true ? 'outline-dark' : 'primary'">
                                Uploader
                            </b-button>
                        </div>
                    </b-col>
                    <b-col cols="12" class="pt-2">
                        <div class="bold">
                            Admin Override
                        </div>
                        <div class="btn-group">
                            <b-button @click="toggleAdminOverride(false)" size="sm" :variant="admin_override_enabled ? 'outline-dark' : 'primary'" :disabled="hasSopData == false">
                                Disabled
                            </b-button>
                            <b-button @click="toggleAdminOverride(true)" size="sm" :variant="admin_override_enabled ? 'primary' : 'outline-dark'" :disabled="hasSopData == false">
                                Enabled
                            </b-button>
                            
                        </div>
                    </b-col>
                </b-row>

            </div>
        </div>
        <b-overlay :show="is_loading" no-wrap></b-overlay>
    </div>
</template>

<script>
import { sopState, sopMethods, clientAdminState} from '@/state/helpers.js'
import { DateTime } from "luxon";
export default {
    data:() => ({
        is_loading: false,
        revision_data: null,
        show_table: false,
        ui:{
            id: 'mergeKeyTable',
            view:'datatable',
            css: "datatableUsers webix_header_border webix_data_border",
            select: 'row',
            hover: 'table_hover',
            autoheight: true,
            fillspace: true,

            columns:[
                /*{ id:"name", header:[
                    "Item", { content: 'textFilter', colspan: 2, placeholder: 'Search...'}
                ], fillspace: 1},*/
                { id: 'name', header:['Item', {content:"textFilter", placeholder:"Search items", colspan:2}], fillspace: 1, },
                { id:"merge_key", header:"Action", fillspace: 0.5,
                    template: '<button type="button" class="btn btn-primary btn-sm insert-button">Insert</button>'
                },
            ],
            on: {
                onItemClick(id){
                    var item = this.getItem(id)
                    console.log(item);
                }
            },
            onClick:{
                //eslint-disable-next-line
                "insert-button":function(event, cell, target){
                    let item = this.getItem(cell);
                    let merge_key = item.merge_key;
                    let el = this.$scope.$parent;
                    el.$eventHub.$emit('insertMergeKey', merge_key);
                    return false; // here it blocks the default behavior
                }
            },
        },

    }),
    computed:{
        ...sopState,
        ...clientAdminState,
        document_builder_enabled(){
            if(!this.sop_data){
                return false;
            }
            else{
                return this.sop_data.builder_enabled;
            }
        },
        admin_override_enabled(){
            if(!this.sop_data){
                return false;
            }
            else{
                return this.sop_data.admin_override;
            }
        },
        merge_keys(){
            let data = [];
            if(this.sop_data != null){
                data = this.sop_data.merge_keys;
            }
            return data;
        },
        hasSopData(){
            //* return true or false -- false == new sop
            if(this.sop_data == null){
                return false;
            }
            else{
                return true;
            }
        },
        isAdmin(){
            //* is user a ccb admin
            let show = false;
            if(this.core_data != null){
                show = this.core_data.ccb_admin
            }
            return show;
        },
        issueDate() {
            if(this.revision_data.issue_date == undefined){
                return 'N/A';
            }
            //return format(new Date(this.revision_data.issue_date), 'MM/DD/YYYY');
            var date = DateTime.fromISO(this.revision_data.issue_date);
            return date.toLocaleString(DateTime.DATETIME_MED);
        },
        can_show_toggles(){
            return this.$store.getters['clientAdmin/userType'] == 'client_admin';
        }
    },
    methods:{
        ...sopMethods,
        initWebixSearch(){
            function isEq(a,b){
                if(a == null){
                    return false;
                }
                a = a.toString().toLowerCase();
                return a.indexOf(b) !== -1;
            }
            //eslint-disable-next-line
            $$("mergeKeyTable").filterByAll=function(){
                //get filter values
                if(this.getFilter("name") == null){
                    return false;
                }
                else{
                    var text = this.getFilter("name").value.toString().toLowerCase();
                    //unfilter for empty search text
                    if (!text) return this.filter();

                    //filter using OR logic
                    this.filter(function(obj){

                        if (isEq(obj.name, text)){
                            return true;
                        }
                        if (isEq(obj.description, text)) {
                            return true;
                        }
                        return false;
                    });
                }
            }
        },
        updateRevisionData(revision){
            this.revision_data = revision;
        },
        handleUpdateSopDocumentMode(state){
            let params = {
                id: this.sop_data.id,
                name: this.sop_data.name,
                builder_enabled: state,
            }
            switch(this.$store.getters['clientAdmin/userType']){
                case 'admin':{
                    params['sop_group_id'] = this.sop_data.sop_group_id;
                    break;
                }
                case 'client_admin':{
                    params['client_group_id'] = this.sop_data.client_sop_group_id;
                    break;
                }
            }
            this.is_loading = true;
            this.saveSopType(params)
            .then(()=>{
                // if(state && this.sop_data.client_revisions.length == 0){
                //     this.insertFirstRevision(this.sop_data.id)
                //     this.is_loading = false;
                // }
                //else{
                    this.loadSopData(this.sop_data.id)
                    .then(()=>{
                        this.is_loading = false;
                    })
                //}
                
            })
        },
        async toggleAdminOverride(state){
            let el = this;
            if(state == this.sop_data.admin_override){
                //* ignore updating admin_override flag if the state is the same
                return;
            }
            

            //* Create Sweetalert input dialog for ENABLING
            if(state){
                const { value: reason } = await this.$swal.fire({
                    title: 'Provide a reason for the activation of administrative override.',
                    input: 'textarea',
                    inputValue: '',
                    inputPlaceholder: '',
                    showCancelButton: true,
                    preConfirm: (inputValue) => {
                        if (inputValue.trim() === '') {
                            this.$swal.showValidationMessage('Please provide a reason.');
                        }
                    }
                })
                if (reason) {
                    this.show_overlay = true;
                    let params = {
                        client_sop_type_id: el.sop_data.id,
                        reason: reason,
                    }
                    el.toggleSopOverride(params)
                    .then(()=>{
                        el.loadSopData(el.sop_data.id);
                    })
                }
            }
            else{
                let params = {
                    client_sop_type_id: el.sop_data.id,
                    reason: '',
                }
                el.toggleSopOverride(params)
                .then(()=>{
                    el.loadSopData(el.sop_data.id);
                })
            }
            
        },
        insertFirstRevision(id){
            let sop_type_id = id;
            let params = {
                sop_type_id: sop_type_id,
                sections:[
                    {
                        section_id: 'list_of_abbreviations',
                        section_order: 1,
                        body: '<p></p>',
                        section_title: 'Abbreviations',
                        content_height: '',
                    },
                    {
                        section_id: 'objective',
                        section_order: 2,
                        body: '<p></p>',
                        section_title: 'Objective',
                        content_height: '',
                    },
                    {
                        section_id: 'scope',
                        section_order: 3,
                        body: '<p></p>',
                        section_title: 'Scope',
                        content_height: '',
                    },
                    {
                        section_id: 'responsibility',
                        section_order: 4,
                        body: '<p></p>',
                        section_title: 'Responsibility',
                        content_height: '',
                    },
                    {
                        section_id: 'policy',
                        section_order: 5,
                        body: '<p></p>',
                        section_title: 'Policy',
                        content_height: '',
                    },
                    {
                        section_id: 'procedure',
                        section_order: 6,
                        body: '<p></p>',
                        section_title: 'Procedure',
                        content_height: '',
                    },
                    {
                        section_id: 'attachments_annexures',
                        section_order: 7,
                        body: '<p></p>',
                        section_title: 'Attachments',
                        content_height: '',
                    }
                ]
            }
            this.saveSopRevision(params)
            .then(()=>{
                this.loadSopData(this.sop_data.id)
                this.$swal.fire({
                    toast: true,
                    position: 'top',
                    iconColor: 'white',
                    icon: 'success',
                    title:'Saved!',
                    customClass: {     popup: 'success-toast' },
                    showConfirmButton: false,
                    timer: 1500,
                    //timer: 2000, timerProgressBar: true
                });
            })
        },
    },
    mounted(){
        this.ui.id = window.webix.uid();
        this.$eventHub.$on('updatedRevisionData', this.updateRevisionData);
        this.show_table = true;
    },
    beforeDestroy(){
        this.$eventHub.$off('updatedRevisionData');
    }
}
</script>

<style>
#notesDropdown>.btn{
    text-decoration: underline;
    border: 0px;
    padding: 0px;
    font-family: var(--bs-font-sans-serif);
    font-size: 0.8125rem;
    transition: all 0.1s cubic-bezier(0.075, 0.82, 0.165, 1);
}
.fa-times{
    transition: all 0.1s linear;
    cursor: pointer;
}
.fa-times:hover{
    color: var(--bs-yellow)!important;
    /*transform: rotate(90deg);*/
    transition: all 0.1s linear;

}

.table_hover{
    background-color: rgba(164, 255, 164, 0.432);
}

.bg-green{
    background: radial-gradient(90.79% 1306.93% at 74.93% 34.21%, #05B15F 0%, #019750 100%);
}
.card-text{
    padding-top: 0.4rem;
    margin-bottom: 0.2rem;
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 1.4rem;
    line-height: 18px;
    color: #FFFFFF;
    text-align: center;
}
</style>